/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateOpportunitySchema } from './candidate-opportunity-schema';
import { experienceSchema } from './experience-schema';

export const candidateOpportunityWarmingQuestionExperienceSchema: z.AnyZodObject = z.object({
  candidateOpportunity: z.lazy(() => candidateOpportunitySchema).nullish(),
  candidateOpportunityId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  experience: z.lazy(() => experienceSchema).nullish(),
  experienceId: z.string().uuid().nullish(),
  id: z.string().uuid(),
  updatedAt: z.string().datetime().nullish(),
});

export type CandidateOpportunityWarmingQuestionExperience = z.infer<typeof candidateOpportunityWarmingQuestionExperienceSchema>;
